import React from 'react';

export const ResizeHandle: React.FC<{ orientation?: 'horizontal' | 'vertical' }> = ({
  orientation = 'vertical',
}) => {
  return (
    <svg
      style={{ transform: orientation === 'vertical' ? 'rotate(90deg)' : 'none' }}
      width="22"
      height="6"
      viewBox="0 0 22 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 0L22 2L20 2L20 -8.74228e-08L22 0ZM17 -2.18557e-07L17 2L15 2L15 -3.0598e-07L17 -2.18557e-07ZM22 4L22 6L20 6L20 4L22 4ZM17 4L17 6L15 6L15 4L17 4ZM12 -4.37114e-07L12 2L10 2L10 -5.24537e-07L12 -4.37114e-07ZM12 4L12 6L10 6L10 4L12 4ZM7 -6.55671e-07L7 2L5 2L5 -7.43094e-07L7 -6.55671e-07ZM7 4L7 6L5 6L5 4L7 4ZM2 -8.74228e-07L2 2L-8.74228e-08 2L0 -9.61651e-07L2 -8.74228e-07ZM2 4L2 6L-2.62268e-07 6L-1.74846e-07 4L2 4Z"
        fill="#868AA5"
      />
    </svg>
  );
};
